// extracted by mini-css-extract-plugin
module.exports = {"tab":"_80ad21f8ef--tab--IhgC7","next-tab-active":"_80ad21f8ef--next-tab-active--oRLSq","active":"_80ad21f8ef--active--SbWyo","disabled":"_80ad21f8ef--disabled--pF4Px"};